// extracted by mini-css-extract-plugin
export var blink = "_5x-2";
export var cursor = "_5x-1";
export var reactMarkdown = "_5x-3";
export var streamingText = "_5x-0";